import { CardContent, CardHeader, CardTitle, Card } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { Help } from '@shared/components';
import * as React from 'react';

type ContactWithUsProps = React.HTMLAttributes<HTMLDivElement>;

export const ContactWithUs: React.FC<ContactWithUsProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>{t('HELP.CONTACT_WITH_US')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Help withTitle={false} />
      </CardContent>
    </Card>
  );
};
